
'use strict';

var React = require('react');
var PropTypes = require('prop-types');

module.exports = function render(props) {
    var innerHtml = '<path id="-a-0-19187" d="M18 13a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm-7 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm-7 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" fill="#58595B" fill-rule="evenodd"/><!-- Filename: sourceSvg/action/small_options.svg -->';
    var svgProps = {
        className: props.className ? (props.className + ' uig-svg-icon') : 'uig-svg-icon',
        dangerouslySetInnerHTML: {__html: innerHtml },
        viewBox: '0 0 22 22'
    }
    return React.createElement('svg', Object.assign({}, props, svgProps));
}
    